export enum MESSAGE_REF_TYPE {
  FORWARD = 1,
  REPLY = 2
}
